import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { TeamsStore } from 'pages/settings/pages/teams/store/TeamsStore'

const TeamsContext = createContext<TeamsStore | null>(null)

export const useTeamsContext = () => {
  const context = useContext(TeamsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with TeamsProvider')

  return context
}

export const TeamsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new TeamsStore(entities), [])

  useEffect(() => store.dispose, [])

  return <TeamsContext.Provider value={store}>{children}</TeamsContext.Provider>
}
